module.exports = __webpack_public_path__ + "static/media/weston.cb4318a0.png";